import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GlobalWrapperService {
  private readonly wrapped$ = new BehaviorSubject(true);
  public readonly wrapped = this.wrapped$.asObservable();

  public hideWrapper() {
    this.wrapped$.next(false);
  }

  public wrap() {
    this.wrapped$.next(true);
  }
}
